import axiosInstance from '../lib/axios';

export const fetchOperationJourney = async ({ queryKey }) => {
    const [_key, { industriesType, filteredData }] = queryKey;
    const response = await axiosInstance.get('/admin/operationJourney', {
        params: { industriesType: industriesType, filteredData: filteredData }
    });
    return response.data;
};
export const fetchIndustries = async ({ queryKey }) => {
    const response = await axiosInstance.get('/admin/allIndustries');
    return response.data;
};
export const addOperationJourney = async (operationJourneyData) => {
    try {
        const response = await axiosInstance.post('/admin/operationJourney', operationJourneyData);

        return response.data;
    } catch (error) {
        console.error('Error adding operation journey:', error);
        throw error;
    }
};
export const updateOperationJourney = async (id, operationJourneyData) => {
    try {
        const response = await axiosInstance.put(`/admin/update-operationJourney/${id}`, operationJourneyData);

        return response.data;
    } catch (error) {
        console.error('Error adding operation journey:', error);
        throw error;
    }
};
export const deleteOperationJourney = (id) => axiosInstance.delete(`/admin/operationJourney/${id}`);
